<template>
    <section class="ops-maint-layout">
        <header class="ops-maint-topbar">
            <nav class="ops-maint-tabs" role="tablist">
                <button
                    v-for="m in modules"
                    :key="m.key"
                    type="button"
                    role="tab"
                    class="ops-maint-tab"
                    :class="{ 'is-active': activeModule === m.key }"
                    :aria-selected="activeModule === m.key ? 'true' : 'false'"
                    @click="onModuleSelect(m.key)"
                >
                    <i :class="m.icon || 'el-icon-setting'"></i>
                    <span>{{ m.title }}</span>
                </button>
            </nav>
            <div class="ops-maint-right">
                <div class="ops-maint-brand" title="系统运维中心">
                    <span class="pulse-dot" aria-hidden="true"></span>
                    <span class="ops-maint-brand-title">系统运维中心</span>
                </div>
                <el-button
                    type="primary"
                    plain
                    size="mini"
                    icon="el-icon-document"
                    class="ops-maint-help-btn"
                    :disabled="!helpOpenFn"
                    @click="openActiveHelp"
                >说明</el-button>
            </div>
        </header>
        <main class="ops-maint-main">
            <transition name="fade-slide" mode="out-in">
                <component :is="activeComponent" v-if="activeComponent" class="active-module-view" />
            </transition>
        </main>
    </section>
</template>

<script>
import MoralHistoryPointConvert from './modules/MoralHistoryPointConvert.vue';
import ReverseCardPayBatch from './modules/ReverseCardPayBatch.vue';
import BalanceRefundPrecheck from './modules/BalanceRefundPrecheck.vue';
import BatchUnbindMainCard from './modules/BatchUnbindMainCard.vue';
import DingTalkPushStyleTrial from './modules/DingTalkPushStyleTrial.vue';

/**
 * 运维维护台入口（分模块）。菜单 LinkUrl 建议：/Maintenance/OpsMaintenanceHub
 * 创建于 2026-05-30
 * 布局于 2026-06-13 改为顶部横向 Tab，释放横向空间
 * 2026-10-20：胶囊 Tab + 钉钉推送试推；顶栏改单行（左 Tab / 右标题+说明）
 */
export default {
    name: 'OpsMaintenanceHub',
    provide() {
        return {
            registerMaintHelp: this.registerMaintHelp,
            unregisterMaintHelp: this.unregisterMaintHelp
        };
    },
    data() {
        return {
            activeModule: 'moralHistoryPointConvert',
            helpOpenFn: null,
            modules: [
                {
                    key: 'moralHistoryPointConvert',
                    title: '历史德育分转积分',
                    icon: 'el-icon-data-analysis',
                    component: MoralHistoryPointConvert
                },
                {
                    key: 'reverseCardPayBatch',
                    title: '反序卡号补扣款',
                    icon: 'el-icon-refresh-left',
                    component: ReverseCardPayBatch
                },
                {
                    key: 'balanceRefundPrecheck',
                    title: '余额退回前置判断',
                    icon: 'el-icon-wallet',
                    component: BalanceRefundPrecheck
                },
                {
                    key: 'batchUnbindMainCard',
                    title: '批量解绑主卡号',
                    icon: 'el-icon-bank-card',
                    component: BatchUnbindMainCard
                },
                {
                    key: 'dingTalkPushStyleTrial',
                    title: '钉钉测试推送',
                    icon: 'el-icon-message',
                    component: DingTalkPushStyleTrial
                }
            ]
        };
    },
    computed: {
        activeComponent() {
            const m = this.modules.find(x => x.key === this.activeModule);
            return m ? m.component : null;
        }
    },
    methods: {
        onModuleSelect(key) {
            this.activeModule = key;
            this.helpOpenFn = null;
        },
        registerMaintHelp(openFn) {
            this.helpOpenFn = typeof openFn === 'function' ? openFn : null;
        },
        unregisterMaintHelp() {
            this.helpOpenFn = null;
        },
        openActiveHelp() {
            if (typeof this.helpOpenFn === 'function') {
                this.helpOpenFn();
            }
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,500&family=IBM+Plex+Sans:wght@400;500;600&display=swap');

.ops-maint-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    min-height: 0;
    background:
        radial-gradient(1200px 420px at 8% -10%, rgba(14, 116, 144, 0.08), transparent 55%),
        radial-gradient(900px 360px at 92% 0%, rgba(15, 118, 110, 0.07), transparent 50%),
        #f4f7f9;
    font-family: 'IBM Plex Sans', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    border-radius: 14px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.ops-maint-topbar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fbfc 100%);
    border-bottom: 1px solid #e2e8f0;
    padding: 8px 12px;
}

.ops-maint-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    margin-left: auto;
}

.ops-maint-brand {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    padding-left: 10px;
    border-left: 1px solid #e2e8f0;
}

.ops-maint-brand-title {
    font-family: 'DM Sans', 'IBM Plex Sans', sans-serif;
    font-weight: 650;
    font-size: 13px;
    letter-spacing: 0.2px;
    color: #64748b;
    line-height: 1.2;
    white-space: nowrap;
}

.pulse-dot {
    width: 7px;
    height: 7px;
    background: #0d9488;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
    box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.55);
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(13, 148, 136, 0.55);
    }
    70% {
        transform: scale(1);
        box-shadow: 0 0 0 6px rgba(13, 148, 136, 0);
    }
    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(13, 148, 136, 0);
    }
}

.ops-maint-tabs {
    display: flex;
    flex: 1 1 auto;
    flex-wrap: nowrap;
    gap: 6px;
    min-width: 0;
    overflow-x: auto;
    padding: 1px 0;
    scrollbar-width: thin;
}

.ops-maint-tabs::-webkit-scrollbar {
    height: 4px;
}

.ops-maint-tabs::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.ops-maint-tab {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    flex: 0 0 auto;
    padding: 6px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    background: #ffffff;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    font-family: inherit;
    line-height: 1.2;
    cursor: pointer;
    transition: color 0.18s ease, background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
    white-space: nowrap;
}

.ops-maint-tab i {
    font-size: 13px;
    color: #94a3b8;
    transition: color 0.18s ease;
}

.ops-maint-tab:hover {
    color: #0f766e;
    border-color: #99f6e4;
    background: #f0fdfa;
}

.ops-maint-tab:hover i {
    color: #0d9488;
}

.ops-maint-tab.is-active {
    color: #ffffff;
    font-weight: 600;
    border-color: transparent;
    background: linear-gradient(135deg, #0f766e 0%, #0e7490 100%);
    box-shadow: 0 4px 12px rgba(14, 116, 144, 0.2);
}

.ops-maint-tab.is-active i {
    color: #ffffff;
}

.ops-maint-help-btn {
    flex-shrink: 0;
}

.ops-maint-main {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 10px 12px 12px;
    overflow: hidden;
    background: transparent;
}

/* transition 不产生包裹节点，class 落在子模块 root；需穿透才能作用。最后更新：2026-09-09 */
.ops-maint-main >>> .active-module-view {
    flex: 1 1 0;
    min-height: 0;
    height: 100%;
    overflow: hidden;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter {
    opacity: 0;
    transform: translateY(10px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}
</style>
